

























import { default as NotificationType, default as notificationType } from "@/model/enum/notification/notificationType"
import { Notification } from "@/model/interfaces/notification/notification"
import { Pagination } from "@/model/interfaces/pagination"
import NotificationModule from "@/store/modules/NotificationModule"
import TemplateSubmissionModule from "@/store/modules/submission/TemplateSubmissionModule"
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({})
export default class NotificationTable extends Vue {
  @Prop({ type: Boolean, default: false }) hasPagination!: boolean
  @Prop({ type: String, default: "60vh" }) height!: string

  get pagination(): Pagination {
    return NotificationModule.pagination
  }

  set pagination(pagination: Pagination) {
    if (this.hasPagination) {
      NotificationModule.mergePagination(pagination)
      NotificationModule.get()
    }
  }

  get loading(): boolean {
    return NotificationModule.loading
  }

  get headers(): Record<string, unknown>[] {
    return [
      {
        text: this.$t("notification.table.header.date"),
        value: "createdAt"
      },
      { text: this.$t("notification.table.header.message"), value: "message", sortable: false },
      { text: this.$t("notification.table.header.template_id"), value: "entityId" },
      { text: this.$t("notification.table.header.country"), value: "country" },
      { text: this.$t("notification.table.header.duty_station"), value: "dutyStation" },
      { text: this.$t("notification.table.header.year"), value: "year" },
      { text: this.$t("notification.table.header.username"), value: "createdBy.username" }
    ]
  }

  get notifications(): Notification[] {
    return NotificationModule.notifications
  }

  get itemsPerPage(): number {
    return NotificationModule.pagination.itemsPerPage
  }

  getMessage(notification: Notification): string {
    if (notification.type === notificationType.GRANTED || notification.type === notificationType.UNGRANTED) {
      return this.$t("notification.type.long_" + notification.type, { username: notification.content?.uamUsername, status: notification.content?.uamStatus }).toString()
    }
    if (notification.type === notificationType.BENEFICIARY_SURVEY_SUBMISSION_CREATED || notification.type === notificationType.PARTNER_SURVEY_SUBMISSION_CREATED) {
      return this.$tc("notification.type.long_" + notification.type, notification.content?.count as number).toString()
    }
    if (
      notification.type === notificationType.BENEFICIARY_SURVEY_SUBMISSIONS_EXPORTER_SUCCESS ||
      notification.type === notificationType.PARTNER_SURVEY_SUBMISSIONS_EXPORTER_SUCCESS ||
      notification.type === notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_EXPORTER_SUCCESS ||
      notification.type === notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_DATABRIDGE_EXPORTER_SUCCESS
    ) {
      const filename = (notification.content?.downloadUrl as string).split("/").pop()
      const params: any = { url: notification.content?.downloadUrl, filename: filename }
      if (
        notification.type === notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_EXPORTER_SUCCESS ||
        notification.type === notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_DATABRIDGE_EXPORTER_SUCCESS
      ) {
        params["template_title"] = notification.content?.title
      }
      return this.$t("notification.type.long_" + notification.type, params).toString()
    }

    if (
      notification.type === notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_EXPORTER_FAIL ||
      notification.type === notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_DATABRIDGE_EXPORTER_FAIL
    ) {
      return this.$t("notification.type." + notification.type, { template_title: notification.content?.title }).toString()
    }

    if (notification.type === notificationType.GLOBAL_INDICATOR_REFRESH) {
      return this.$t("notification.type." + notification.type, {
        details:
          !notification.content ||
          Object.entries(notification.content).filter(([, value]) => {
            return value !== null
          }).length === 0
            ? "all"
            : Object.entries(notification.content)
                .filter(([, value]) => {
                  return value !== null
                })
                .map(([key, value]) => {
                  return `${key}: ${value}`
                })
                .join(", ")
      }).toString()
    }

    return this.$t("notification.type." + notification.type).toString()
  }

  routeTo(notification: Notification): void {
    if (notification.entityId !== undefined) {
      if (
        [notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_EXPORTER_SUCCESS, notificationType.SURVEY_SUBMISSIONS_BY_TEMPLATE_EXPORTER_FAIL].includes(
          notification.type as NotificationType
        )
      ) {
        this.$router.push({ name: "survey-management" })
        return
      }
      TemplateSubmissionModule.setSearch(notification.entityId.toString())
      this.$router.push({ name: "overview" })
    }
  }
}
